import { Link as MuiLink, LinkProps } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledLink = styled(MuiLink)`
  cursor: pointer;
`;

export const Link = (props: LinkProps) => {
  const { ...args } = props;
  return <StyledLink {...args} />;
};

export default Link;
